/**
 * Loop through capabilities to see if any spatiall layers capabilities
 * enabled. The category value of 3 is meant for spatial layers
 * @param {Array} capabilities - List of capabilities
 */
const canViewSpatialLayers = capabilities => {
  const category = 3;
  if (!capabilities || typeof capabilities !== 'object') {
    return false;
  }
  const values = Object.values(capabilities);
  const result = values.find(o => o.category === category);
  return !!result;
};

export default canViewSpatialLayers;
